import { useCallback, useEffect, useState } from 'react';
import { usePortalApiRequest } from '../../../redux/api/portalApi';
import { getSalesArrayPayload, useSalesEndpoints } from '../hooks/useSalesApiResource';
import { normalizers } from './configurationAdminUtils';
import { evaluateQuoteAdvancedRules } from './advancedQuoteRules';

export default function useAdvancedQuoteRules() {
  const endpoints = useSalesEndpoints();
  const request = usePortalApiRequest();
  const [state, setState] = useState({ loading: true, data: null, error: '' });
  const reload = useCallback(async () => {
    setState({ loading: true, data: null, error: '' });
    try {
      const rules = getSalesArrayPayload(await request({ method: 'GET', url: endpoints.advancedConfigRules.base }));
      const data = { rules };
      for (const [resource, endpoint] of [['stations', 'masterStationList'], ['fields', 'configFields'], ['fieldValues', 'configFieldValues'], ['valueRules', 'configValueRules']]) {
        data[resource] = normalizers[resource](getSalesArrayPayload(await request({ method: 'GET', url: endpoints[endpoint].base })));
      }
      setState({ loading: false, data, error: '' });
    } catch (error) { setState({ loading: false, data: null, error: `Global rules could not load: ${error.message || 'Request failed'}` }); }
  }, [endpoints, request]);
  useEffect(() => { reload(); }, [reload]);
  const evaluate = useCallback(quote => state.data ? evaluateQuoteAdvancedRules(quote, state.data) : {
    quote, updates: [], isValid: false, errors: [{ message: state.error || 'Global rules are still loading.' }],
  }, [state]);
  return { ...state, evaluate, reload };
}
